import { Fill, Stroke, Style } from 'ol/style';

export const styleFunction = (feature, resolution) => {
  const layer = feature.get('layer');
  const kind = feature.get('kind');
  const geometry = feature.getGeometry();

  // Style cho boundaries (ranh giới)
  if (layer === 'boundaries') {
    return new Style({
      stroke: new Stroke({
        color: '#ff6b6b',
        width: 2,
      }),
      fill: new Fill({
        color: 'rgba(255, 107, 107, 0.1)',
      }),
    });
  }

  // Style cho roads (đường)
  if (layer === 'roads') {
    let color = '#666666';
    let width = 1;

    if (kind === 'major_road') {
      color = '#ff9f43';
      width = 3;
    } else if (kind === 'minor_road') {
      color = '#a4b0be';
      width = 2;
    } else if (kind === 'driveway' || kind === 'service') {
      color = '#ddd';
      width = 1;
    }

    return new Style({
      stroke: new Stroke({
        color: color,
        width: width,
      }),
    });
  }

  // Style cho earth (đất)
  if (layer === 'earth') {
    return new Style({
      fill: new Fill({
        color: 'rgba(139, 195, 74, 0)',
      }),
    });
  }

  // Default style
  return new Style({
    stroke: new Stroke({
      color: '#333',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 0, 0.1)',
    }),
  });
};
